import { Component, Inject, input, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { WINDOW } from '@core/injectors';
import { SnowflakeUrlData, UserInfo } from '@core/models';
import { OrganizationsService, ThemeService } from '@core/services';

@Component({
  selector: 'app-tools-panel',
  templateUrl: './tools-panel.component.html',
  styleUrl: './tools-panel.component.scss',
  standalone: false,
})
export class ToolsPanelComponent implements OnInit {
  userInfo = input.required<UserInfo>();
  isDarkTheme = signal<boolean>(false);
  snowflakeUrl = toSignal<SnowflakeUrlData | null>(this.organizationsService.selectedOrganizationSnowflakeUrl);
  thoughtSpotUrl = toSignal<string | null>(this.organizationsService.selectedOrganizationThoughtSpotUrl);

  constructor(
    private readonly router: Router,
    private readonly themeService: ThemeService,
    private organizationsService: OrganizationsService,
    @Inject(WINDOW) private readonly win: Window,
  ) {}

  ngOnInit(): void {
    this.isDarkTheme.set(this.themeService.isDarkTheme);
  }

  onToggle() {
    this.themeService.toggle();
    this.isDarkTheme.set(this.themeService.isDarkTheme);
  }

  navigateToProduct(url: string | null) {
    return url ? this.win.open(url) : url;
  }

  initiateSnowflakeSSO(snowflakeUrlData: SnowflakeUrlData): void {
    if (snowflakeUrlData.use_sso) {
      const tree = this.router.createUrlTree(['sso/snowflake_sso_login'], {
        queryParams: { link: snowflakeUrlData.url },
      });
      const serializedUrl = this.router.serializeUrl(tree);
      const fullUrl = `${this.win.location.origin}${serializedUrl}`;
      this.win.open(fullUrl, '_blank');
    } else {
      this.win.open(snowflakeUrlData.url, '_blank');
    }
  }

  navigateToDilikoStatusPage() {
    this.win.open('https://diliko.statuspage.io/');
  }
}
